import { render, staticRenderFns } from "./change-date.vue?vue&type=template&id=5902582a&"
import script from "./change-date.vue?vue&type=script&lang=js&"
export * from "./change-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/change-date.vue
// module id = 1687
// module chunks = 0